import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ButtonModule } from '@components/button';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'share-payment-how-it-works',
  templateUrl: './share-payment-how-it-works.html',
  imports: [CommonModule, ButtonModule, ButtonCtaComponent],
})
export class SharePaymentHowItWorksComponent {
  data = inject<any>(MAT_BOTTOM_SHEET_DATA);
  private readonly bottomSheetRef = inject(MatBottomSheetRef);
  private readonly eventLogger = inject(EventLoggerService);

  isCCODEligible: boolean = false;
  orderSP: number = 0;
  // When opened as the back-press nudge, render the "Can't Pay Online?" header
  // and dismiss with a result so the host can navigate back on close.
  backPopup: boolean = false;

  ngOnInit(): void {
    this.isCCODEligible = this.data?.isCCODEligible ?? false;
    this.orderSP = this.data?.orderSP || 0;
    this.backPopup = this.data?.backPopup ?? false;
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({
      pageName: 'share_payment_how_it_works_shown',
      backPopup: this.backPopup,
      ccodEligible: this.isCCODEligible,
    }));
  }

  onCtaClick(): void {
    if (this.isCCODEligible) {
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'generate_payment_link_clicked' }));
      this.bottomSheetRef.dismiss();
      if (this.data?.onGenerateLink) {
        this.data.onGenerateLink();
      }
    } else {
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'share_payment_link_direct_clicked' }));
      this.bottomSheetRef.dismiss();
      if (this.data?.onShareDirectly) {
        this.data.onShareDirectly();
      }
    }
  }

  closeBottomSheet(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({
      name: 'share_payment_how_it_works_closed',
      backPopup: this.backPopup,
      ccodEligible: this.isCCODEligible,
    }));
    // Closing the back-press nudge should take the user to the previous screen;
    // a backdrop tap dismisses with no result and keeps them on the payment page.
    this.bottomSheetRef.dismiss(this.backPopup ? 'NAVIGATE_BACK' : undefined);
  }
}
